// EVES-2969 - Add Timezone in Transfer Report
export const getClientTimezone = () => {
  const resolvedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZone =
    resolvedTimeZone === "Asia/Calcutta" ? "Asia/Kolkata" : resolvedTimeZone;

  const offsetInMinutes = new Date().getTimezoneOffset();
  const formatOffset = (offset: number) => {
    const sign = offset <= 0 ? "+" : "-";
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
    return `${sign}${hours}:${minutes}`;
  };
  const offset = formatOffset(offsetInMinutes);

  return { timeZone, offset };
};
